import React from 'react';

export default (props) => {
    const right = props.right === undefined || props.right === true ? 'text-right' : '';

    return (
        <div className={`px-4 py-3 bg-gray-50 sm:px-6 ${right} ${props.className}`}>
            {props.children}
        </div>
    );
};
